import { render, staticRenderFns } from "./Vop.vue?vue&type=template&id=4a5d8627&scoped=true&"
import script from "./Vop.vue?vue&type=script&lang=ts&"
export * from "./Vop.vue?vue&type=script&lang=ts&"
import style0 from "./Vop.vue?vue&type=style&index=0&id=4a5d8627&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5d8627",
  null
  
)

export default component.exports